import { Box, IconButton, useTheme, Tooltip } from "@mui/material"
import { useTranslate } from "react-admin";
import { useNavigate } from "react-router-dom";





const Icon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-list-details">
            <path stroke="none" d="M0 0h20v20H0z" fill="none" stroke-width="0.8333333333333334" />
            <path d="M10.833 4.167h6.667" />
            <path d="M10.833 7.5h4.167" />
            <path d="M10.833 12.5h6.667" />
            <path d="M10.833 15.833h4.167" />
            <path d="M2.5 4.167a0.833 0.833 0 0 1 0.833 -0.833h3.333a0.833 0.833 0 0 1 0.833 0.833v3.333a0.833 0.833 0 0 1 -0.833 0.833H3.333a0.833 0.833 0 0 1 -0.833 -0.833z" />
            <path d="M2.5 12.5a0.833 0.833 0 0 1 0.833 -0.833h3.333a0.833 0.833 0 0 1 0.833 0.833v3.333a0.833 0.833 0 0 1 -0.833 0.833H3.333a0.833 0.833 0 0 1 -0.833 -0.833z" />
        </svg>



    )
}







export const VoucherBatchesButton = ({ }) => {
    const theme = useTheme();
    const translate = useTranslate();
    const navigate = useNavigate()

    return (
        <Box sx={{
            padding: "0px",
            marginRight: "20px",
        }}>

            <Tooltip enterDelay={300} title={translate('resources.vouchers.view_voucher_batches')} >
                <IconButton
                    sx={{
                        padding: "4px",
                    }}
                    onClick={() => {
                        navigate('/voucher_batches');
                    }}
                >
                    <Icon color={theme.palette.primary.dark} />
                </IconButton>
            </Tooltip>


        </Box>

    )


}